import {Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, useDisclosure,
    Button, Tooltip } from '@chakra-ui/react'
import { BsPrinter } from "react-icons/bs"
import { useRef, useState } from 'react'
import { PDFViewer } from '@react-pdf/renderer'
import PDFCurrentAccount from './PDFCurrectAccount'
import { useNavigate } from "react-router-dom";
import authService from "../services/authService"
import moment from 'moment'

const PrintPDFCurrentAccount = ({ nameCustomer, totalSale, totalPaid, balance, data, completeAccount, fromDate, toDate }) => {
    const { isOpen: isOpenPrintPDFCurrentAccount, onOpen: onOpenPrintPDFCurrentAccount, onClose: onClosePrintPDFCurrentAccount } = useDisclosure()
    const initialRef = useRef(null)
    const [ loading, setLoading ] = useState(false)

    const navigate = useNavigate();

    const handleOpen = () => {        
        onOpenPrintPDFCurrentAccount()
    }

    return (
        <>
            <Tooltip label='Imprimir'><Button size="sm" colorScheme='messenger' onClick={handleOpen} style={{gap: 8}}><BsPrinter/>Imprimir</Button></Tooltip>

            <Modal
                initialFocusRef={initialRef}
                isOpen={isOpenPrintPDFCurrentAccount}
                onClose={onClosePrintPDFCurrentAccount}
                size='3xl'
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Cuenta Corriente</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <PDFViewer width="720px" height="400px">
                            <PDFCurrentAccount nameCustomer={nameCustomer} totalSale={totalSale} totalPaid={totalPaid} balance={balance} data={data} completeAccount={completeAccount} fromDate={fromDate} toDate={toDate} />
                        </PDFViewer>
                    </ModalBody>

                </ModalContent>
            </Modal>
        </>
    )
}

export default PrintPDFCurrentAccount